import React from "react";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Button,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function AddEmployee() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1); // this goes one step back in history
  };
  const [value, setValue] = React.useState({
    page: "0",
    gender: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [activeTab, setActiveTab] = React.useState(0);
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Add New Employee
            </h1>
          </div>

          <div className="right_s">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>

        <div className="cards">
          <form>
            <div className="gap_m">
              <div className="control_group w_100">
                <label>Image Upload</label>
                <figure className="upload_image no_img  centered">
                  <input type="file" />
                  <figcaption>
                    <img src="/static/images/user_circle.png" alt="icon" />
                  </figcaption>
                </figure>
              </div>

              <div className="control_group w_33">
                <label>Name</label>
                <TextField
                  placeholder="Enter Name"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>

              <div className="control_group w_33">
                <label>Email</label>
                <TextField
                  placeholder="Enter Email"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>

              <div className="control_group w_33">
                <label>Phone no.</label>
                <TextField
                  placeholder="Enter Phone "
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>

              <div className="w_50 control_group">
                <label>Date of birth</label>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className="form_control"
                    slots={{
                      openPickerIcon: () => (
                        <img
                          src="/static/images/calendar_icon.svg"
                          alt="icon"
                        />
                      ),
                      textField: (params) => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="Date of birth"
                          hiddenLabel
                        />
                      ),
                    }}
                    desktopModeMediaQuery="(min-width:0px)"
                  />
                </LocalizationProvider>
              </div>

              <div className="control_group w_50">
                <label>Gender</label>
                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  value={value.gender}
                  name="gender"
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
                    Select gender
                  </MenuItem>

                  <MenuItem value="10">Male</MenuItem>
                  <MenuItem value="20">Female</MenuItem>
                </Select>
              </div>
            </div>
          </form>
        </div>
      </MainContainer>
    </>
  );
}

export default AddEmployee;
